import accordionItem from "./accordionItem.component";

const accordionItemModule = angular
  .module("app.components.accordionItem", [])
  .component("accordionItem", accordionItem);

export default accordionItemModule;



// WEBPACK FOOTER //
// ./src/components/accordionItem/accordionItem.module.js